import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IMonTuongDuong } from "../../../model/respone/category/IMonTuongDuong";
import { IMonTuongDuongViewModel } from "../../../model/respone/category/IMonTuongDuongViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMonTuongDuongActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IMonTuongDuongViewModel[],
  LOAD_ERRR: "",


  SHOW_EDIT_MODAL: {} as IMonTuongDuong | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IMonTuongDuong,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: {} as IIdsRequest,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

  CHANGE_SELECTED_IDS: {} as number[],

  CHANGE_FILTER: {} as IMonTuongDuongFilter,

};

export interface IMonTuongDuongFilter {
  id_he: number;
}
export const eMonTuongDuongActionIds = generateActionTypeIds(
  eMonTuongDuongActionsObj,
  "MON_TUONG_DUONG"
);
export type IMonTuongDuongActionTypes = IGenericActionType<
  typeof eMonTuongDuongActionsObj,
  "MON_TUONG_DUONG"
>;
